import { ICONES_MENSAGEM } from "../utils/icones.jsx";

function Incompativel() {
  return (
    <div className="m-4">
      <div className="d-flex align-items-center text-danger">
        <div className="mb-1 me-2">{ICONES_MENSAGEM.ERRO}</div>
        <span className="fw-bold-destaque">
          Acesse o SIIG via computador ou tablet
        </span>
      </div>
    </div>
  );
}

export default Incompativel;
